import { customerInfomation } from '../queries/queries'

const queryCustomerInfomation = (id, success, error) => {
  return {
    type: 'API:CUSTOMER_HOME:INFOMATION',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: customerInfomation.QUERY_CUSTOMER_INFOMATION,
      variables: { id }
    },
    success,
    error
  }
}

const queryCustomerPhotos = (variables, success, error) => {
  return {
    type: 'API:CUSTOMER_HOME:CUSTOMER_PHOTOS',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: customerInfomation.QUERY_CUSTOMER_PHOTOS,
      variables
    },
    success,
    error
  }
}

const queryCustomerPerfectProducts = (variables, success, error) => {
  return {
    type: 'API:CUSTOMER_HOME:PERFECT_PRODUCTS',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: customerInfomation.QUERY_CUSTOMER_PERFECT_PRODUCTS,
      variables
    },
    success,
    error
  }
}

const queryCustomerStyleAlbum = (variables, success, error) => {
  return {
    type: 'API:CUSTOMER_HOME:STYLE_ALBUM',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: customerInfomation.QUERY_CUSTOMER_STYLE_ALBUM,
      variables
    },
    success,
    error
  }
}

export default {
  queryCustomerInfomation,
  queryCustomerPhotos,
  queryCustomerPerfectProducts,
  queryCustomerStyleAlbum
}
